module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_011.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_011.png
// module id = 934
// module chunks = 0